import { getUser } from "@/lib/api";

export default function SettingsPage() {
  const user = getUser();
  return (
    <div className="p-6 lg:p-10 max-w-3xl">
      <div className="text-xs txt-mono uppercase tracking-widest text-muted-foreground">Engine</div>
      <h1 className="text-3xl font-semibold tracking-tight mt-1">Settings</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-8">Global engine configuration.</p>

      <section className="border border-border p-5 mb-6">
        <h3 className="text-sm font-semibold mb-3">Operator account</h3>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <div className="text-[10px] txt-mono uppercase text-muted-foreground">Email</div>
            <div className="txt-mono mt-1">{user?.email}</div>
          </div>
          <div>
            <div className="text-[10px] txt-mono uppercase text-muted-foreground">User ID</div>
            <div className="txt-mono mt-1 text-xs truncate">{user?.id}</div>
          </div>
        </div>
      </section>

      <section className="border border-border p-5 mb-6">
        <h3 className="text-sm font-semibold mb-3">LLM configuration</h3>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <div className="text-[10px] txt-mono uppercase text-muted-foreground">Provider</div>
            <div className="txt-mono mt-1">OpenAI</div>
          </div>
          <div>
            <div className="text-[10px] txt-mono uppercase text-muted-foreground">Model</div>
            <div className="txt-mono mt-1">gpt-5.4</div>
          </div>
          <div className="col-span-2">
            <div className="text-[10px] txt-mono uppercase text-muted-foreground">API key</div>
            <div className="txt-mono text-xs mt-1 text-muted-foreground">
              Configured via <code>OPENAI_API_KEY</code> in <code>/app/backend/.env</code>. Restart the backend after edits.
            </div>
          </div>
        </div>
      </section>

      <section className="border border-border p-5">
        <h3 className="text-sm font-semibold mb-3">About</h3>
        <p className="text-xs text-muted-foreground leading-relaxed">
          Programmatic UGC Forum Engine v0.1 — Home Services pack MVP. Drip publisher
          running every 60 seconds. Vertical Packs architecture allows adding new
          niches (Financial Services, Insurance, AI Companion, iGaming &amp; Crypto) without
          touching core code.
        </p>
      </section>
    </div>
  );
}
